import React, { Component } from "react";
import PropTypes from "prop-types";
import { InvoiceService } from "@services";
import classNames from "classnames";
import utils from "@utils";
import Modal from "../Modal/Modal";
import Loader from "../Loader/Loader";

class DisputeInvoiceModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			disputeReasons: [],
			DisputeReasonId: "",
			Note: "",
			invalidReason: false,
			invalidNote: false,
			showConfirmation: false,
			loading: false,
		};
	}

	componentDidMount = () => {
		this.getDisputeReasons();
	};

	getDisputeReasons = () => {
		InvoiceService.getDisputeReasons()
			.then(({ data }) => {
				const disputeReasons = data.map(({ Reason, Id }) => ({ label: Reason, value: Id }));
				this.setState({ disputeReasons });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: "Error getting dispute reasons",
				});
			});
	};

	submitDispute = () => {
		const { Id, Note, DisputeReasonId } = this.state;
		this.setState({ loading: true });

		InvoiceService.submitDisputeForm(Id, Note, DisputeReasonId)
			.then(() => {
				this.setState({ loading: false });

				utils.notify({
					type: "success",
					message: "Dispute submitted successfully",
				});

				this.setState({ showConfirmation: true });
			})
			.catch(() => {
				this.setState({ loading: false });

				utils.notify({
					type: "error",
					message: "Error submitting dispute",
				});
			});
	};

	onKeyPress = ({ key }) => {
		if (key === "Enter") {
			this.validate();
		}
	};

	validate = () => {
		const { DisputeReasonId, Note } = this.state;

		const invalidReason = DisputeReasonId === "" ? "has-error" : "";
		const invalidNote = Note === "" || /^ *$/.test(Note) ? "has-error" : "";

		this.setState({ invalidNote, invalidReason });

		if (!(invalidNote || invalidReason)) this.submitDispute();
	};

	open = Id => this.setState({ Id, isOpen: true });

	close = () => {
		const { onSubmit } = this.props;
		const { showConfirmation } = this.state;

		if (showConfirmation) onSubmit();

		this.setState({
			isOpen: false,
			showConfirmation: false,
			Id: "",
			DisputeReasonId: "",
			Note: "",
		});
	};

	onChange = ({ target: { name, value } }) => this.setState({ [name]: value });

	render() {
		const { lang } = global;
		const {
			isOpen,
			Id,
			disputeReasons,
			DisputeReasonId,
			Note,
			invalidNote,
			invalidReason,
			showConfirmation,
			loading,
		} = this.state;

		return (
			<Modal
				show={isOpen}
				onHide={this.close}
			>
				<div className="modal-header text-center">
					<h4>
						{showConfirmation
							? lang.t("Dispute Submitted")
							: lang.t("Dispute an Invoice")}
					</h4>
				</div>
				<div className="modal-body">
					<Choose>
						<When condition={showConfirmation}>
							<div className="text-center">
								<img
									className="checkmark"
									src="/images/checkmark.png"
									alt="dispute submitted successfully"
								/>
							</div>
							<div>{lang.t("The officer has been notified_")}</div>
							<p>{lang.t("please keep an eye on your email for further updates_")}</p>
							<h4>{lang.t("Dispute Details")}</h4>
							<div>
								<strong>{lang.t("Invoice ID")}</strong>
								<div>{Id}</div>
							</div>
							<br />
							<div>
								<strong>{lang.t("Reason for Dispute")}</strong>
								<div>
									{disputeReasons.find(
										({ value }) => value === parseInt(DisputeReasonId, 10),
									)?.label || ""}
								</div>
							</div>
							<br />
							<div>
								<strong>{lang.t("Note")}</strong>
								<div>{Note}</div>
							</div>
						</When>
						<Otherwise>
							<p>
								{lang.t("You have selected to dispute invoice")} #{Id}
							</p>
							<div className={classNames("form-group", invalidReason)}>
								<label
									className="control-label"
									htmlFor="DisputeReasonId"
								>
									{lang.t("Reason")}
								</label>
								<select
									id="DisputeReasonId"
									name="DisputeReasonId"
									className="form-control"
									value={DisputeReasonId}
									onChange={this.onChange}
								>
									<option value="">{lang.t("Select a reason")}</option>
									<For
										index="index"
										each="reason"
										of={disputeReasons}
									>
										<option
											key={`reason_option_${reason.value}`}
											value={reason.value}
										>
											{reason.label}
										</option>
									</For>
								</select>
							</div>
							<div className={classNames("form-group", invalidNote)}>
								<label
									className="control-label"
									htmlFor="Note"
								>
									{lang.t("Add Notes")}
								</label>
								<textarea
									id="Note"
									name="Note"
									className="form-control"
									placeholder={lang.t(
										"(Please explain why you are disputing this invoice)",
									)}
									value={Note}
									onChange={this.onChange}
									onKeyPress={this.onKeyPress}
								/>
							</div>
						</Otherwise>
					</Choose>
				</div>
				<If condition={!showConfirmation}>
					<div className="modal-footer">
						<div className="text-center">
							<button
								type="button"
								id="submit-dispute"
								className="btn btn-primary"
								onClick={this.validate}
							>
								{lang.t("Submit")}
							</button>
							<button
								type="button"
								className="btn btn-link"
								onClick={this.close}
							>
								{lang.t("Cancel")}
							</button>
						</div>
					</div>
				</If>
				<Loader active={loading} />
			</Modal>
		);
	}
}

DisputeInvoiceModal.propTypes = {
	onSubmit: PropTypes.func.isRequired,
};

export default DisputeInvoiceModal;
